import { useState, useEffect, useCallback } from 'react';
import { useAddressDialogContext } from '../../AddressDialog.provider';

export const useAddressConfirmationController = () => {
  const { setStep, onClose, onSaveAddress, originalAddress, suggestedAddress, mutationLoading } = useAddressDialogContext();
  const [isSuggestedAddressSelected, setIsSuggestedAddressSelected] = useState<boolean>(true);

  const handlePreviousStep = useCallback(() => {
    setStep(1);
  }, [setStep]);

  const setSuggestedAddressSelected = () => {
    setIsSuggestedAddressSelected(true);
  };

  const setOriginalAddressSelected = useCallback(() => {
    setIsSuggestedAddressSelected(false);
  }, []);

  const saveSelectedAddress = useCallback(() => {
    onSaveAddress(isSuggestedAddressSelected);
  }, [isSuggestedAddressSelected, onSaveAddress]);

  const hasToHideAddressConfirmationDialog = !suggestedAddress || !originalAddress;
  useEffect(() => {
    if (hasToHideAddressConfirmationDialog) {
      handlePreviousStep();
    }
  }, [hasToHideAddressConfirmationDialog, handlePreviousStep]);

  return {
    hasToHideAddressConfirmationDialog,
    handlePreviousStep,
    setSuggestedAddressSelected,
    setOriginalAddressSelected,
    isSuggestedAddressSelected,
    saveSelectedAddress,
    originalAddress,
    onClose,
    suggestedAddress,
    mutationLoading
  };
};
